import React from 'react';

const About = () => {
   return (
      <div>
         <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
            <div className="max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12">
               <div>
                  <p className="inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-teal-accent-400">
                     Brand new
                  </p>
               </div>
               <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto">
                  <span className="relative inline-block">
                     <svg
                        viewBox="0 0 52 24"
                        fill="currentColor"
                        className="absolute top-0 left-0 z-0 hidden w-32 -mt-8 -ml-20 text-blue-gray-100 lg:w-32 lg:-ml-28 lg:-mt-10 sm:block"
                     >
                        <defs>
                           <pattern id="07690130-d013-42bc-83f4-90de7ac68f76" x="0" y="0" width=".135" height=".30">
                              <circle cx="1" cy="1" r=".7" />
                           </pattern>
                        </defs>
                        <rect fill="url(#07690130-d013-42bc-83f4-90de7ac68f76)" width="52" height="24" />
                     </svg>
                     <span className="relative">The</span>
                  </span>{' '}
                  We Believe Software Should Make You Happy
               </h2>
               <p className="text-base text-gray-700 md:text-lg">Delightfully smart tools with awesome support</p>
            </div>
            <div className="grid max-w-screen-lg mx-auto space-y-6 lg:grid-cols-2 lg:space-y-0 lg:divide-x">
               <div className="space-y-6 sm:px-16">
                  <div className="flex flex-col max-w-md sm:flex-row">
                     <div className="mb-4 mr-4">
                        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-50">
                           <svg
                              className="w-8 h-8 text-deep-purple-accent-400 sm:w-10 sm:h-10"
                              stroke="currentColor"
                              viewBox="0 0 52 52"
                           >
                              <polygon
                                 strokeWidth="3"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 fill="none"
                                 points="29 13 14 29 25 29 23 39 38 23 27 23"
                              />
                           </svg>
                        </div>
                     </div>
                     <div>
                        <h6 className="mb-3 text-xl font-bold leading-5">The deep ocean</h6>
                        <p className="text-sm text-gray-900">
                           Webtwo ipsum orkut reddit meebo skype vimeo jajah spock empressr zimbra, mobly napster.
                        </p>
                     </div>
                  </div>
                  <div className="flex flex-col max-w-md sm:flex-row">
                     <div className="mb-4 mr-4">
                        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-50">
                           <svg
                              className="w-8 h-8 text-deep-purple-accent-400 sm:w-10 sm:h-10"
                              stroke="currentColor"
                              viewBox="0 0 52 52"
                           >
                              <polygon
                                 strokeWidth="3"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 fill="none"
                                 points="29 13 14 29 25 29 23 39 38 23 27 23"
                              />
                           </svg>
                        </div>
                     </div>
                     <div>
                        <h6 className="mb-3 text-xl font-bold leading-5">When has justice</h6>
                        <p className="text-sm text-gray-900">
                           Lookout flogging bilge rat main sheet bilge water nipper fluke to go on account heave down
                           clap of thunder.
                        </p>
                     </div>
                  </div>
                  <div className="flex flex-col max-w-md sm:flex-row">
                     <div className="mb-4 mr-4">
                        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-50">
                           <svg
                              className="w-8 h-8 text-deep-purple-accent-400 sm:w-10 sm:h-10"
                              stroke="currentColor"
                              viewBox="0 0 52 52"
                           >
                              <polygon
                                 strokeWidth="3"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 fill="none"
                                 points="29 13 14 29 25 29 23 39 38 23 27 23"
                              />
                           </svg>
                        </div>
                     </div>
                     <div>
                        <h6 className="mb-3 text-xl font-bold leading-5">Leverage agile</h6>
                        <p className="text-sm text-gray-900">
                           The first mate and his Skipper too will do their very best to make the others comfortable.
                        </p>
                     </div>
                  </div>
               </div>
               <div className="space-y-6 sm:px-16">
                  <div className="flex flex-col max-w-md sm:flex-row">
                     <div className="mb-4 mr-4">
                        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-50">
                           <svg
                              className="w-8 h-8 text-deep-purple-accent-400 sm:w-10 sm:h-10"
                              stroke="currentColor"
                              viewBox="0 0 52 52"
                           >
                              <polygon
                                 strokeWidth="3"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 fill="none"
                                 points="29 13 14 29 25 29 23 39 38 23 27 23"
                              />
                           </svg>
                        </div>
                     </div>
                     <div>
                        <h6 className="mb-3 text-xl font-bold leading-5">Organically grow</h6>
                        <p className="text-sm text-gray-900">
                           Skate ipsum dolor sit amet, alley oop vert mute-air Colby Carter flail 180 berm over the sea.
                        </p>
                     </div>
                  </div>
                  <div className="flex flex-col max-w-md sm:flex-row">
                     <div className="mb-4 mr-4">
                        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-50">
                           <svg
                              className="w-8 h-8 text-deep-purple-accent-400 sm:w-10 sm:h-10"
                              stroke="currentColor"
                              viewBox="0 0 52 52"
                           >
                              <polygon
                                 strokeWidth="3"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 fill="none"
                                 points="29 13 14 29 25 29 23 39 38 23 27 23"
                              />
                           </svg>
                        </div>
                     </div>
                     <div>
                        <h6 className="mb-3 text-xl font-bold leading-5">Have a good one</h6>
                        <p className="text-sm text-gray-900">
                           Cheese on toast airedale the big cheese. Danish fontina cheesy grin airedale danish fontina.
                        </p>
                     </div>
                  </div>
                  <div className="flex flex-col max-w-md sm:flex-row">
                     <div className="mb-4 mr-4">
                        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-50">
                           <svg
                              className="w-8 h-8 text-deep-purple-accent-400 sm:w-10 sm:h-10"
                              stroke="currentColor"
                              viewBox="0 0 52 52"
                           >
                              <polygon
                                 strokeWidth="3"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 fill="none"
                                 points="29 13 14 29 25 29 23 39 38 23 27 23"
                              />
                           </svg>
                        </div>
                     </div>
                     <div>
                        <h6 className="mb-3 text-xl font-bold leading-5">A slice of heaven</h6>
                        <p className="text-sm text-gray-900">
                           A flower in my garden, a mystery in my panties. Heart attack never stopped old Big Bear.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default About;
